import React from "react";

const IconNewsletterSubmit = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="#ECAE8C" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0)">
			<path d="M5.83203 11.7412V14.8332C5.83203 15.0492 5.9707 15.2405 6.17603 15.3085C6.22736 15.3252 6.28003 15.3332 6.33203 15.3332C6.48803 15.3332 6.63869 15.2599 6.73469 15.1292L8.54335 12.6679L5.83203 11.7412Z" />
			<path d="M15.79 0.0927257C15.6367 -0.0159409 15.4354 -0.0306076 15.2687 0.0567257L0.268696 7.89006C0.091363 7.98273 -0.0133037 8.17206 0.00136299 8.37139C0.0166963 8.57139 0.149363 8.74206 0.33803 8.80673L4.50803 10.2321L13.3887 2.63873L6.5167 10.9181L13.5054 13.3067C13.5574 13.3241 13.612 13.3334 13.6667 13.3334C13.7574 13.3334 13.8474 13.3087 13.9267 13.2607C14.0534 13.1834 14.1394 13.0534 14.1614 12.9074L15.9947 0.574059C16.022 0.387392 15.9434 0.202059 15.79 0.0927257Z"/>
		</g>
		<defs>
			<clipPath id="clip0">
				<rect width="16" height="16" fill="white"/>
			</clipPath>
		</defs>
	</svg>
);

export default IconNewsletterSubmit;


